import { render } from "./IncomesBySource.vue?vue&type=template&id=244a8a07&scoped=true"
import script from "./IncomesBySource.vue?vue&type=script&lang=js"
export * from "./IncomesBySource.vue?vue&type=script&lang=js"

import "./IncomesBySource.vue?vue&type=style&index=0&id=244a8a07&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244a8a07"]])

export default __exports__